export default __webpack_public_path__ + "static/media/surrounding3.68db3879.jpg";